import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";
export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [showPass, setShowPass] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  axios.defaults.withCredentials = true;

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(`${process.env.REACT_APP_BACKEND_BASE_URL}/user/login`, {
        email,
        password,
      })
      .then((res) => {
        if (res.status === 200) {
          const encryptedData = CryptoJS.AES.encrypt(
            JSON.stringify(res.data.data),
            process.env.REACT_APP_LOGIN_SEC
          ).toString();
          localStorage.setItem(
            process.env.REACT_APP_LOGIN_DATA_STORE,
            encryptedData
          );

          if (res.data.data.role_name === "Admin") {
            Swal.fire({
              icon: "success",
              title: "Login successfully",
              timer: 1500,
            }).then(() => {
              navigate("/admindashbord");
            });
          } else {
            Swal.fire({
              icon: "success",
              title: "Login successfully",
              timer: 1500,
            }).then(() => {
              navigate("/");
            });
          }
        } else {
          Swal.fire({
            icon: "warning",
            title: "Wrong Email or Password",
            timer: 1500,
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          Swal.fire({
            icon: "warning",
            title: "Invalid Email or Password",
            timer: 1500,
          });
        } else {
          console.error("Login Error:", err);
          Swal.fire({
            icon: "error",
            title: "Something went wrong",
            text: "Please try again later",
          });
        }
      });
  };
  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          {/* <div className="login-logo-circle"></div> */}
          <img src="/assets/img/ca-logo.jpg" alt="Logo" className="logo" />
          <h2>S D P M Admin Login</h2>
          <p>Access your admin dashboard securely</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="login-field">
            <label>Email / Username</label>
            <input
              type="email"
              placeholder="admin@domain.com"
              // value={email}
              autoFocus
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="login-field">
            <label>Password</label>
            <div className="password-box">
              <input
                type={showPass ? "text" : "password"}
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPass(!showPass)}
              >
                {showPass ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          <div className="login-options">
            <label className="remember-me">
              <input type="checkbox" /> Remember me
            </label>
            <Link to="/forgot-password">
              <button type="button" className="forgot-link">
                Forgot password?
              </button>
            </Link>
          </div>

          <button type="submit" className="login-button">
            Login
          </button>
        </form>
      </div>
    </div>
  );
}
